module.exports = __webpack_public_path__ + "img/1207.47f5a84b.jpg";